import {get as _get} from 'lodash';

class Config {
    get = (path) => {
      const key = path.match(/^REACT_APP_/) ? path : `REACT_APP_${path}`
      let value = _get(process.env, key)

      // 資料型態轉換
      if (value === 'true')  value = true
      if (value === 'false') value = false

      return value
    }
}

export default new Config();